import { styled } from "@mui/material/styles";
import {
  Avatar as MuiBadge, Typography
} from "@mui/material";

export const BadgeContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const BadgeAndLabelContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.space._200,
  borderRadius: "6.25rem",
}));

export const LabelTypography = styled(Typography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontStyle: "normal",
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.base,
}));

export const CustomBadge = styled(MuiBadge)(({ theme }) => ({
  backgroundSize: "200% auto",
  border: '1px solid',
  backgroundColor: 'transparent',

  fontWeight: theme.fontWeights.bold,
  fontFamily: theme.fonts.default,
  lineHeight: '110%',

  ".MuiBadge-fallback": {
    width: "60%",
    height: "60%",
  },
}));
